/**
 * @generated SignedSource<<d79bcecd8f9db609e7a93f62c3d1051a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HomepageMixedGridItemSource = "AD" | "EDITORIAL" | "EDITORS_PICKS" | "RECOMMENDATIONS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HpPersonalizedMixedGridResp_viewer$data = {
  readonly homepageMixedGrid?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly item: {
            readonly __typename: "EditorialItem";
            readonly cmsId: number | null;
            readonly cta: string | null;
            readonly header: string | null;
            readonly imageUrl: string | null;
            readonly linkData: {
              readonly path: string | null;
            };
            readonly title: string | null;
          } | {
            readonly __typename: "HomepageMixedGridAdSlot";
            readonly slot: number;
          } | {
            readonly __typename: "Item";
            readonly serviceId: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_item">;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          };
          readonly itemSource: HomepageMixedGridItemSource;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_viewer">;
  readonly " $fragmentType": "HpPersonalizedMixedGridResp_viewer";
};
export type HpPersonalizedMixedGridResp_viewer$key = {
  readonly " $data"?: HpPersonalizedMixedGridResp_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpPersonalizedMixedGridResp_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "fetchFavorites",
  "variableName": "hasUserId"
},
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "abTestList"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "homepageId"
    },
    {
      "kind": "RootArgument",
      "name": "isMobile"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isPersonalizedContentAboveFoldTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "mixedGridAfter"
    },
    {
      "defaultValue": 8,
      "kind": "LocalArgument",
      "name": "mixedGridFirst"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": "PERSONALIZED",
      "kind": "LocalArgument",
      "name": "recommendationType"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "mixedGridFirst",
        "cursor": "mixedGridAfter",
        "direction": "forward",
        "path": [
          "homepageMixedGrid",
          "items"
        ]
      }
    ]
  },
  "name": "HpPersonalizedMixedGridResp_viewer",
  "selections": [
    {
      "args": [
        (v0/*:: as any*/),
        (v1/*:: as any*/)
      ],
      "kind": "FragmentSpread",
      "name": "UserRecommendationsRecommendationTile_viewer"
    },
    {
      "condition": "isPersonalizedContentAboveFoldTestVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "abTestList",
              "variableName": "abTestList"
            },
            {
              "kind": "Variable",
              "name": "homepageId",
              "variableName": "homepageId"
            },
            {
              "kind": "Variable",
              "name": "isMobile",
              "variableName": "isMobile"
            },
            {
              "kind": "Variable",
              "name": "recommendationType",
              "variableName": "recommendationType"
            },
            (v1/*:: as any*/),
            {
              "kind": "Variable",
              "name": "userType",
              "variableName": "userType"
            }
          ],
          "concreteType": "HomepageMixedGrid",
          "kind": "LinkedField",
          "name": "homepageMixedGrid",
          "plural": false,
          "selections": [
            {
              "alias": "items",
              "args": null,
              "concreteType": "HomepageMixedGridItemsConnection",
              "kind": "LinkedField",
              "name": "__HpPersonalizedMixedGrid_items_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HomepageMixedGridItemsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HomepageMixedGridItemEntry",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "itemSource",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "item",
                          "plural": false,
                          "selections": [
                            (v2/*:: as any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "serviceId",
                                  "storageKey": null
                                },
                                {
                                  "args": [
                                    (v0/*:: as any*/),
                                    {
                                      "kind": "Variable",
                                      "name": "isTrade",
                                      "variableName": "isTrade"
                                    },
                                    {
                                      "kind": "Variable",
                                      "name": "priceBookName",
                                      "variableName": "priceBookName"
                                    },
                                    (v1/*:: as any*/)
                                  ],
                                  "kind": "FragmentSpread",
                                  "name": "UserRecommendationsRecommendationTile_item"
                                }
                              ],
                              "type": "Item",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "cmsId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "title",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "header",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "imageUrl",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "cta",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "LinkData",
                                  "kind": "LinkedField",
                                  "name": "linkData",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "path",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "EditorialItem",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "slot",
                                  "storageKey": null
                                }
                              ],
                              "type": "HomepageMixedGridAdSlot",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v2/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*:: as any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "UserRecommendationsRecommendationTile_user"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "16ee031cf323c000522cde9955dac372";

export default node;
